import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-counter',
  templateUrl: './event-counter.component.html',
  styleUrls: ['./event-counter.component.scss']
})
export class EventCounterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
